import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const Locate = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path d="M3.963 8.32 19.1 3.078a1.43 1.43 0 0 1 1.82 1.82l-5.24 15.138a1.41 1.41 0 0 1-1.377.963 1.41 1.41 0 0 1-1.342-1.01l-2.107-6.845-6.845-2.107a1.43 1.43 0 0 1-.047-2.719Z" />
  </Icon>
);

export default Locate;
